import Vue from 'vue'
import Vuex from 'vuex'
import app from './app'
import auth from './auth'
import news from './news'
import image from './image'

import snackbar from './snackbar'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    app,
    auth,
    snackbar,
    news,
    image
  }
})
